import Head from 'next/head';
import { jsx as _jsx } from "react/jsx-runtime";
var PageHead = function PageHead(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Head, {
    children: children
  });
};
export default PageHead;